<template>
  <div class="flex">
    <svg-icon type="mdi" :path="path"></svg-icon>
  </div>
</template>

<script>

import SvgIcon from '@jamescoyle/vue-icon';
import { mdiAirplaneTakeoff } from "@mdi/js"

export default {
  name: "AirplaneTakeoffIcon",
  components: {
    SvgIcon
  },
  data() {
    return {
      path: mdiAirplaneTakeoff,
    }
  }
}
</script>
